import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import {  Home20Regular,
  BookInformation20Regular,
  PersonAdd20Regular,
  Folder20Regular,
  ChevronRight20Regular} from '@fluentui/react-icons';
import { PounctMenu } from './PounctMenu';
import { ME } from '../../graphql/queries';
import { usePageContext } from '../../hooks/PageContext';

interface SidebarContentProps {
  istocopen?: boolean; // ← добавь
}

const Nav = styled.nav`
  ul {
    list-style: none;
    padding: 20px 0 0 0;
    margin: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;


export const SidebarContent: React.FC<SidebarContentProps> = ({ istocopen = false }) => {
  const { data, loading } = useQuery(ME);
  const user = data?.me;
  const { actions } = usePageContext();

  const [arrowReady, setArrowReady] = useState(false);

    useEffect(() => {
      // После первого рендера разрешаем анимацию.
      // Поэтому при загрузке страницы стрелка НЕ крутится.
      const timer = requestAnimationFrame(() => {
        setArrowReady(true);
      });

      return () => cancelAnimationFrame(timer);
    }, []);

    const TocArrow = styled.span<{
      $isOpen: boolean;
      $animate: boolean;
    }>`
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      flex-shrink: 0;

      ${({ $isOpen, $animate }) =>
        $animate
          ? `
            animation: ${$isOpen ? 'tocArrowOpen' : 'tocArrowClose'} 0.5s ease forwards;
          `
          : `
            transform: rotate(${$isOpen ? 180 : 0}deg);
          `}

      @keyframes tocArrowOpen {
        from {
          transform: rotate(0deg);
        }

        to {
          transform: rotate(-180deg);
        }
      }

      @keyframes tocArrowClose {
        from {
          transform: rotate(-180deg);
        }

        to {
          transform: rotate(0deg);
        }
      }
    `;

  const forAdmins = user
    ? ['admin', 'superadmin'].includes(user.role) 
    : false;

  if (loading) return null; 

  return (
  <Nav>
    <ul>
      <PounctMenu to="/Home" icon={<Home20Regular />}>
        Главная
      </PounctMenu>

      <PounctMenu 
        to="/Blog" 
          onClick={() => {
            // ✅ Сбрасываем фильтр при клике на "Помощь"
            actions?.setTagFilter(null);
            actions?.setSearch('');
            actions?.setMode('list');
          }}
        icon={
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <BookInformation20Regular />
          </div>
        }
      >
        Помощь                             
      <div
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          window.dispatchEvent(new CustomEvent('toggleTOC'));
        }}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 24,
          height: 24,
          cursor: 'pointer',
          color: 'white',
          borderRadius: 4,
          transition: 'background-color 0.2s',

          // положение стрелочки относительно текста
          marginLeft: 60,
          position: 'relative',
          top: 1,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.2)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
        }}
        title={istocopen ? 'Свернуть оглавление' : 'Открыть оглавление'}
      >
        <TocArrow $isOpen={istocopen} $animate={arrowReady}>
          <ChevronRight20Regular />
        </TocArrow>
      </div>
      </PounctMenu>

      {/* <PounctMenu to="/Instructions" icon={<Phone20Regular />}>
       Руководство по установке
      </PounctMenu>*/}

      <PounctMenu to="/Dist" icon={<Folder20Regular />}>
        Загрузить
      </PounctMenu>

        {/* Отображаем "Свор" только при наличии доступа 
        {hasAccess && (
          <PounctMenu to="/Svor" icon={<Link20Regular />}>
            Свор
          </PounctMenu>
        )}*/}
        {forAdmins && (
          <PounctMenu to="/Administration" icon={<PersonAdd20Regular />}>
            Панель администратора
          </PounctMenu>
        )}
    </ul>
  </Nav>
);
}